var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarlogo5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 527 527",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M263.3,3.7C120.2,3.7,3.5,120.4,3.5,263.5c0,143.1,116.7,259.8,259.8,259.8c143.1,0,259.8-116.7,259.8-259.8 C523,120.4,406.3,3.7,263.3,3.7L263.3,3.7z M263.3,493.3c-126.6,0-229.8-103.2-229.8-229.8c0-126.6,103.2-229.8,229.8-229.8 s229.8,103.2,229.8,229.8C493.1,390.1,389.8,493.3,263.3,493.3L263.3,493.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.9,439.1C120.6,410,72.6,342.2,72.6,263.5c0-20,3.1-39.3,8.9-57.5L188.9,439.1L188.9,439.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.2,446.7c-16.8,4.9-34.6,7.5-53,7.5c-18.4,0-36.1-2.6-52.9-7.5l52.9-123.5L316.2,446.7L316.2,446.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.1,206.1c5.8,18.1,8.9,37.4,8.9,57.4c0,78.7-48.1,146.5-116.3,175.5L445.1,206.1L445.1,206.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.4,98.9c23.3,13.7,43.4,32.1,59.1,54l-95,201.9l-32-77.1h-56.4l-32,77.1l-95-201.9c15.7-21.9,35.8-40.4,59.1-54 l66.6,155.5h59L359.4,98.9L359.4,98.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.3,72.8c18.6,0,36.7,2.7,53.7,7.7l-53.7,129.3L209.6,80.5C226.6,75.5,244.6,72.8,263.3,72.8L263.3,72.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarlogo5);
export default __webpack_public_path__ + "static/media/carlogo (5).9e7546cca2f5426cc5ca493c1bb1b5ae.svg";
export { ForwardRef as ReactComponent };